export const MARKETSTORE_LIST_FAILED = 'MARKETSTORE_LIST_FAILED';
export const MARKETSTORE_LIST_SUCCESS = 'MARKETSTORE_LIST_SUCCESS';
export const MARKETSTORE_LIST_ATTEMPT = 'MARKETSTORE_LIST_ATTEMPT';
export const LOGOUT = "LOGOUT";